export const API_KEY_SCOPE_OPTIONS = [
  {
    value: 'read',
    label: 'Read',
    description: 'List accounts, transactions, balances',
  },
  {
    value: 'write',
    label: 'Write',
    description: 'Propose transactions and update memos',
  },
  { value: 'owner', label: 'Owner', description: 'Admin operations' },
] as const

export type ApiKeyScope = (typeof API_KEY_SCOPE_OPTIONS)[number]['value']
